import { Injectable } from '@angular/core';
import { DevtoolsDetectionConfig } from './security.types';

@Injectable({
  providedIn: 'root'
})
export class DevtoolsDetectionService {

  private _timerId: ReturnType<typeof setInterval> | null = null;

  start(config: DevtoolsDetectionConfig): void {
    if (!config.enabled || this._timerId) return;

    this._timerId = setInterval(() => {
      const startedAt = performance.now();

      // This is intentionally non-blocking. DevTools detection is best-effort only.
      console.debug('');

      const elapsedMs = performance.now() - startedAt;
      if (elapsedMs > config.thresholdMs) {
        // Reserved for future telemetry or UX hooks.
      }
    }, config.intervalMs);
  }

  stop(): void {
    if (!this._timerId) return;

    clearInterval(this._timerId);
    this._timerId = null;
  }

}
